import { FC } from "react";
import { Helmet } from "react-helmet";
import CommonLayout from "../AccountPage/CommonLayout";
import ReservationGridDetailedCard from "../Reservation/ReservationGridDetailedCard";

export interface AccountPageProps {
  className?: string;
}

const ClientReservationsPage: FC<AccountPageProps> = ({ className = "" }) => {
  return (
    <CommonLayout>
      <div
        className={`overflow-hidden relative nc-ListingFlightsPage ${className}`}
        data-nc-id="ListingFlightsPage"
      >
        <Helmet>
          <title>
            EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France
          </title>
        </Helmet>

        <div className="">
          <ReservationGridDetailedCard className="pb-24 lg:b-28" />
        </div>
      </div>
    </CommonLayout>
  );
};

export default ClientReservationsPage;
